import './App.css';
// import { useConnect } from 'wagmi'
// import { injected } from 'wagmi/connectors'


import { BrowserRouter, Routes, Route, useParams } from "react-router";

import { useEffect, useState } from 'react'
import { useAccount } from 'wagmi';


import loading_gif from './component/images/loading_gif.gif';

import Alert from './component/Alert';
import BnbPro_Before_Login from './component/BnbPro_Before_Login';
import BnbPro_After_Login from './component/BnbPro_After_Login';

import Bnb_SignUp_Area from './component/Bnb_SignUp_Area';

import {Login_Detail, Refferal_Detail, Refferal_SignUp} from './component/Data_Structure';

import { useConnect } from 'wagmi'
import { injected } from 'wagmi/connectors'


let url = "https://fxcprofit.pro/";
// let url = "http://localhost:3000/";

let direct_login = false;
// let direct_login = true;

//---------------------------Modal_Area---------------------------------------------------

function LoadingModal(props) {

  useEffect(() => {
    document.body.style.overflowY = "hidden";
    return () => {
      document.body.style.overflowY = "scroll";
    }
  }, []);
  return (
    <>     
      <div className='modal-wrapper' style={{zIndex: 100}}></div>
        {/*<div className='fixed-top'>
            <div style={{ZIndex: 9, height: '56px', backgroundColor: 'rgba(189, 189, 189, 0.9)'}}></div>
        </div>*/}
      {
        props.isLoading === true ? (
          <>
            <div className='modal-container' style={{zIndex: 101, background: 'white'}}>
              <table style={{width: '100%', background: 'white'}}>
                <tbody>
                  <tr>
                    <td style={{width: '100%', background: 'white'}}>                      
                      <img style={{width: '80px', height: '80px', background: 'white'}} src={loading_gif} alt="loading"/>
                    </td>
                  </tr>                  
                </tbody>
              </table>
            </div>
          </>
        ) : (
          <></>
        )
      }
    </>
  );
}


function Main_Component(props) {

  const { connectors, connect } = useConnect();
  const { address } = useAccount();

  const [Login_Try_Count, SetLogin_Try_Count] = useState(Number(0));
  const [IsLogin, SetIsLogin] = useState(false);
  
  const [LoadingModal_Show, SetLoadingModal_Show] = useState(false);
  const [LoadingModal_isLoading, SetLoadingModal_IsLoading] = useState(true);

  const SetLoadingModal = async(istrue, isloading) => {
    SetLoadingModal_Show(istrue);
    SetLoadingModal_IsLoading(isloading);
  }

  const SignIn_Click = async() => {
    if (direct_login === false) {
      
      try {
        connect({ connector: injected() });

        // connect({ 
        //   connector: injected({
        //     target() {
        //       // 1. Look for TokenPocket inside a multi-provider extension environment
        //       const provider = window.ethereum?.providers?.find((p) => p.isTokenPocket) 
        //         || window.ethereum?.isTokenPocket ? window.ethereum : undefined;

        //       return {
        //         id: 'tokenPocket',
        //         name: 'TokenPocket',
        //         provider: provider,
        //       };
        //     },
        //   })
        // });


        // connect({ 
        //   connector: injected({
        //     options: {
        //       name: 'TokenPocket',
        //       getProvider: () => {
        //         if (typeof window === 'undefined') return undefined;
                
        //         return window.ethereum?.providers?.find((p) => p.isTokenPocket) 
        //           || (window.ethereum?.isTokenPocket ? window.ethereum : undefined);
        //       }
        //     }
        //   })
        // });

        // // Look through your config connectors to find the customized one we built above
        // const tpConnector = connectors.find((c) => c.id === 'tokenPocket')

        // if (tpConnector) {
        //   connect({ connector: tpConnector })
        // } 
        // else {
        //   // Fallback if the connector didn't register cleanly
        //   alert('TokenPocket connector not found or extension missing!')
        // }
        
      }
      catch(error) {
        console.log("Signed In Error");
        console.log(error);
      }
    }
    else if (direct_login === true) {
      SetIsLogin(true);
    }
  }
  const SignUp_Click = async() => {
    let ref = "589678347";          //  593712981
    window.location.replace(url + "r/" + ref);
  }

  useEffect(() => {
    const Check_Address = async() => {

      if (address === undefined || address === "" || address === " ") {
        SetIsLogin(false);
      }
      else {
        // SetIsLogin(true);
        // props.showAlert("SuccessFully Logined!...", "success", true);

        Login_Detail(address, SetIsLogin, props.showAlert);
      }
      
      // if (Number(Login_Try_Count) === Number(0)) {
        // SetLogin_Try_Count(Number(1));
      // }
      // else if (Number(Login_Try_Count) === Number(1)) {
      //   SetLogin_Try_Count(Number(2));
      // }
      // else if (Number(Login_Try_Count) === Number(2)) {
      //   SetLogin_Try_Count(Number(2));
      // }
    }
    Check_Address();
  }, [address]);


  return (
    <>
      {
        IsLogin === false ? (
          <>
            <BnbPro_Before_Login SignIn_Click={SignIn_Click} SignUp_Click={SignUp_Click} showAlert={props.showAlert}/>
          </>
        ) : IsLogin === true ? (
          <>
            <BnbPro_After_Login SetIsLogin={SetIsLogin} SetLoadingModal={SetLoadingModal} showAlert={props.showAlert}/>
          </>
        ) : (
          <></>
        )
      }

      {
        LoadingModal_Show === true ? (
          <>
            <LoadingModal isLoading={LoadingModal_isLoading} SetLoadingModal={SetLoadingModal}/>
          </>
        ) : (
          <></>
        )
      }
    </>
  );
}

function Refferal_Component(props) {

  
  const { connect } = useConnect();
  const {address} = useAccount();
  
  const param = useParams();

  const [LoadingModal_Show, SetLoadingModal_Show] = useState(false);
  const [LoadingModal_isLoading, SetLoadingModal_IsLoading] = useState(false);
  

  
  const SetLoadingModal = async(istrue, isloading) => {
    SetLoadingModal_Show(istrue);
    SetLoadingModal_IsLoading(isloading);
  }
  
  

  return (
    <>

      <Bnb_SignUp_Area connect={connect} injected={injected} address={address} param={param} SetLoadingModal={SetLoadingModal} showAlert={props.showAlert} />

      { 
        LoadingModal_Show === true ? (
          <>
            <LoadingModal isLoading={LoadingModal_isLoading} SetLoadingModal={SetLoadingModal}/>
          </>
        ) : (
          <></>
        )
      }
    </>
  );
}

function App() {
  
  const [alert, setAlert] = useState(null);

  //-------------Alert-Area--------------------
  const showAlert = (message, type, timeout_true) => {
    setAlert({
      message: message,
      type: type,
    });

    if (timeout_true === true) {
      setTimeout(() => {
        setAlert(null);
      }, 4000);
    }
  }

  useEffect(() => {
    document.body.style.overflowX = "hidden";
  }, []);

  return (
    <div className="App" style={{overflowX: "hidden"}}>
        <Alert alert={alert}/>

        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Main_Component showAlert={showAlert}/>}></Route>
            <Route path="/r/:id" element={<Refferal_Component showAlert={showAlert}/>}></Route>
          </Routes>
        
        </BrowserRouter>
    </div>
  );
}

export default App;
